import '../../../App.css'
import { useState, useEffect } from 'react';
import { Modal, Input, Table, } from 'antd';
import axios from 'axios';
import Appconfig from '../../../config/config'
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { TfiPencilAlt } from "react-icons/tfi";
import { useNavigate, } from "react-router-dom";


function Betting() {
    const navigate = useNavigate();

    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const [openNews, setOpenNews] = useState(false)
    const [button, setButton] = useState(false)


    const [eventTypes, setEventTypes] = useState([])
    const [formData, setFormData] = useState({
        domain_name: "",
        site_code: "",
    });
    const [id, setId] = useState('')

    const handleSetFormData = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };


    function getEventTypes() {
        var data = JSON.stringify({
            user_id: userInfo?._id,
        });

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}betting/getEventTypes`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.result) {
                    setEventTypes(response.data.resultData)
                }
                else {
                    console.log(response)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const navigateToDetails = (event_type) => {
            navigate(`/betting/eventOpenBetting/${event_type}`);
    };


    const columns = [
        {
            title: 'S.N.',
            sorter: true,
            render: (_, record,i) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>{i + 1}</span>
            ),
        },
        {
            title: 'Sport Name',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#315195] text-[0.813rem] ml-[5px]' onClick={() => navigateToDetails(record.event_type)}>{record.name}</span>
            ),
        },
     

    ];

    useEffect(() => {
        getEventTypes();
    }, [])

    return (
        <>
            <NotificationContainer />
           

            <div className='w-full px-[10px] lg:px-[20px] mt-[20px] lg:mt-[15px]'>
                <div className='w-full'>
                    <div className='grid grid-cols-12'>

                    {/* Header */}
                    <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] h-[35px] rounded-[1px] bg-[#0c9971] text-[#ffffff] flex items-center justify-between'>
                        <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>Betting Sports</h5>
                    </div>

                    {/* Table Section */}
                    <div className='col-span-12'>
                        <div className='bg-[#fff] border border-[#0000002d]'>
                        <div className='p-[0.75rem]'>
                            <Table
                            columns={columns}
                            className='downline-list w-full'
                            bordered
                            dataSource={eventTypes}
                            pagination={false}
                            />
                            <div className='grid grid-cols-12 items-center pt-[1.5rem] lg:pt-[.75rem] text-[#333]'></div>
                        </div>
                        </div>
                    </div>

                    </div>
                </div>
            </div>

        </>
    )
}


export default Betting;
